import Vue from 'vue'
import ElementUI from 'element-ui'
import moment from 'moment'
import FullCalendar from 'vue-full-calendar'
import VueTuicalendar from '@lkmadushan/vue-tuicalendar'
import { RecycleScroller } from 'vue-virtual-scroller'
import thLocale from 'element-ui/lib/locale/lang/th'
import 'element-ui/lib/theme-chalk/index.css'
import 'tui-calendar/dist/tui-calendar.min.css'
import './element-variables.scss'
import './fullcalendar.scss'
import App from './App'
import router from './router'
import * as api from './services'
import './style.scss'
import '../node_modules/font-awesome/css/font-awesome.min.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.config.productionTip = false

Vue.use(ElementUI, { locale: thLocale })
Vue.use(FullCalendar)
Vue.use(VueTuicalendar)
Vue.component('RecycleScroller', RecycleScroller)

moment.locale('th')

Vue.mixin({
  computed: {
    $api () {
      return api
    },
  },
})

if (window.OneSignal) {
  window.OneSignal.init({
    appId: process.env.VUE_APP_NOTI_APP_ID,
    allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production',
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
})
